import { Link } from 'react-router-dom';
import { Logo } from './Logo';

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="shell footer-grid">
        <div className="footer-brand">
          <Logo />
          <p>A practical image workspace with 17 AI tools for enhancement, repair and generative editing, plus 8 clearly labeled free browser utilities for everyday image preparation.</p>
        </div>
        <div>
          <h3>Product</h3>
          <Link to="/tools">All tools</Link>
          <Link to="/tools/enhance">Image enhancer</Link>
          <Link to="/tools/upscale">Image upscaler</Link>
          <Link to="/tools/restore">Photo restoration</Link>
          <Link to="/tools/deblur">Unblur photos</Link>
          <Link to="/tools/remove-background">Background remover</Link>
          <Link to="/tools/object-remover">Object remover</Link>
          <Link to="/tools/image-extender">AI image extender</Link>
          <Link to="/tools/compress">Free image compressor</Link>
          <Link to="/pricing">Pricing</Link>
          <Link to="/plans-and-credits">Plans & credits</Link>
        </div>
        <div>
          <h3>Resources</h3>
          <Link to="/guides">Image guides</Link>
          <Link to="/guides/increase-image-resolution-without-losing-quality">Increase image resolution</Link>
          <Link to="/guides/scan-old-photos-for-ai-restoration">Scan and restore old photos</Link>
          <Link to="/guides/jpg-png-webp-avif-image-format-guide">Image format guide</Link>
          <Link to="/faq">Help & FAQ</Link>
          <Link to="/about">About</Link>
          <Link to="/methodology">Editorial methodology</Link>
          <Link to="/contact">Contact support</Link>
          <Link to="/sitemap">Sitemap</Link>
        </div>
        <div>
          <h3>Legal</h3>
          <Link to="/privacy">Privacy policy</Link>
          <Link to="/terms">Terms of service</Link>
          <Link to="/acceptable-use">Acceptable use</Link>
          <Link to="/refund-policy">Refund policy</Link>
          <Link to="/cookies">Cookie & storage policy</Link>
          <a href="/sitemap.xml">XML sitemap</a>
        </div>
      </div>
      <div className="shell footer-bottom">
        <span>© {new Date().getFullYear()} Nexhance AI.</span>
        <span>AI uploads are processed to deliver the requested result and temporary outputs are scheduled for removal. Free browser utilities process locally without an AI upload.</span>
      </div>
    </footer>
  );
}
